<template>
  <Teleport to="body">
    <div class="modal-overlay" @click="$emit('close')">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h2 class="text-xl font-semibold text-gray-900">
            {{ $t('rgpd.preferences.title') }}
          </h2>
          <button
              @click="$emit('close')"
              class="text-gray-400 hover:text-gray-600"
          >
            <Icon name="heroicons:x-mark" class="h-6 w-6" />
          </button>
        </div>

        <div class="modal-body">
          <p class="text-sm text-gray-600 mb-6">
            {{ $t('rgpd.preferences.description') }}
          </p>

          <!-- Cookie essentiel (toujours activé) -->
          <div class="cookie-category">
            <div class="category-header">
              <div class="flex items-center justify-between">
                <h3 class="font-medium text-gray-900">
                  {{ $t('rgpd.preferences.categories.essential.title') }}
                </h3>
                <div class="toggle-container">
                  <div class="toggle toggle-disabled">
                    <ToggleSwitch v-model="essential" />
                  </div>
                  <span class="toggle-label">
                    {{ $t('rgpd.preferences.categories.essential.status') }}
                  </span>
                </div>
              </div>
              <p class="text-sm text-gray-500 mt-1">
                {{ $t('rgpd.preferences.categories.essential.description') }}
              </p>
            </div>
          </div>

          <!-- Cookies d'analyse -->
          <div class="cookie-category">
            <div class="category-header">
              <div class="flex items-center justify-between">
                <h3 class="font-medium text-gray-900">
                  {{ $t('rgpd.preferences.categories.analytics.title') }}
                </h3>
                <div class="toggle-container">
<!--                  <button-->
<!--                      @click="preferences.analytics = !preferences.analytics"-->
<!--                      :class="[-->
<!--                      'toggle',-->
<!--                      preferences.analytics ? 'toggle-active' : 'toggle-inactive'-->
<!--                    ]"-->
<!--                  >-->
<!--                    <div :class="[-->
<!--                      'toggle-switch',-->
<!--                      preferences.analytics ? 'toggle-switch-active' : 'toggle-switch-inactive'-->
<!--                    ]"></div>-->
<!--                  </button>-->
                  <ToggleSwitch v-model="preferences.analytics" />
                  <span class="toggle-label">
                    {{ preferences.analytics
                      ? $t('rgpd.preferences.status.enabled')
                      : $t('rgpd.preferences.status.disabled')
                    }}
                  </span>
                </div>
              </div>
              <p class="text-sm text-gray-500 mt-1">
                {{ $t('rgpd.preferences.categories.analytics.description') }}
              </p>
              <div v-if="preferences.analytics" class="cookie-details">
                <p class="text-xs text-gray-400">
                  {{ $t('rgpd.preferences.categories.analytics.examples') }}
                </p>
              </div>
            </div>
          </div>

          <!-- Cookies marketing -->
          <div class="cookie-category">
            <div class="category-header">
              <div class="flex items-center justify-between">
                <h3 class="font-medium text-gray-900">
                  {{ $t('rgpd.preferences.categories.marketing.title') }}
                </h3>
                <div class="toggle-container">
<!--                  <button-->
<!--                      @click="preferences.marketing = !preferences.marketing"-->
<!--                      :class="[-->
<!--                      'toggle',-->
<!--                      preferences.marketing ? 'toggle-active' : 'toggle-inactive'-->
<!--                    ]"-->
<!--                  >-->
<!--                    <div :class="[-->
<!--                      'toggle-switch',-->
<!--                      preferences.marketing ? 'toggle-switch-active' : 'toggle-switch-inactive'-->
<!--                    ]"></div>-->
<!--                  </button>-->
                  <ToggleSwitch v-model="preferences.marketing" />
                  <span class="toggle-label">
                    {{ preferences.marketing
                      ? $t('rgpd.preferences.status.enabled')
                      : $t('rgpd.preferences.status.disabled')
                    }}
                  </span>
                </div>
              </div>
              <p class="text-sm text-gray-500 mt-1">
                {{ $t('rgpd.preferences.categories.marketing.description') }}
              </p>
              <div v-if="preferences.marketing" class="cookie-details">
                <p class="text-xs text-gray-400">
                  {{ $t('rgpd.preferences.categories.marketing.examples') }}
                </p>
              </div>
            </div>
          </div>

          <!-- Cookies de préférence -->
          <div class="cookie-category">
            <div class="category-header">
              <div class="flex items-center justify-between">
                <h3 class="font-medium text-gray-900">
                  {{ $t('rgpd.preferences.categories.preferences.title') }}
                </h3>
                <div class="toggle-container">
<!--                  <button-->
<!--                      @click="preferences.preferences = !preferences.preferences"-->
<!--                      :class="[-->
<!--                      'toggle',-->
<!--                      preferences.preferences ? 'toggle-active' : 'toggle-inactive'-->
<!--                    ]"-->
<!--                  >-->
<!--                    <div :class="[-->
<!--                      'toggle-switch',-->
<!--                      preferences.preferences ? 'toggle-switch-active' : 'toggle-switch-inactive'-->
<!--                    ]"></div>-->
<!--                  </button>-->
                  <ToggleSwitch v-model="preferences.preferences" />
                  <span class="toggle-label">
                    {{ preferences.preferences
                      ? $t('rgpd.preferences.status.enabled')
                      : $t('rgpd.preferences.status.disabled')
                    }}
                  </span>
                </div>
              </div>
              <p class="text-sm text-gray-500 mt-1">
                {{ $t('rgpd.preferences.categories.preferences.description') }}
              </p>
              <div v-if="preferences.preferences" class="cookie-details">
                <p class="text-xs text-gray-400">
                  {{ $t('rgpd.preferences.categories.preferences.examples') }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <div class="flex gap-3 justify-end">
            <button
                @click="$emit('close')"
                class="btn-secondary"
            >
              {{ $t('rgpd.preferences.actions.cancel') }}
            </button>
            <button
                @click="acceptAll"
                class="btn-accept-all"
            >
              {{ $t('rgpd.preferences.actions.accept_all') }}
            </button>
            <button
                @click="savePreferences"
                class="btn-save"
            >
              {{ $t('rgpd.preferences.actions.save') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
const emit = defineEmits(['close', 'save'])

const essential = ref(true)
// État des préférences
const preferences = ref({
  analytics: false,
  marketing: false,
  preferences: false
})

// Initialiser avec les préférences existantes si disponibles
onMounted(() => {
  const { cookieTypes } = useCookieConsent()
  preferences.value = {
    analytics: cookieTypes.analytics,
    marketing: cookieTypes.marketing,
    preferences: cookieTypes.preferences
  }
})

const savePreferences = () => {
  emit('save', preferences.value)
}

const acceptAll = () => {
  preferences.value = {
    analytics: true,
    marketing: true,
    preferences: true
  }
  emit('save', preferences.value)
}
</script>

<style scoped>
.modal-overlay {
  @apply fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4;
}

.modal-content {
  @apply bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto;
}

.modal-header {
  @apply flex justify-between items-center p-6 border-b border-gray-200;
}

.modal-body {
  @apply p-6 space-y-6;
}

.modal-footer {
  @apply p-6 border-t border-gray-200 bg-gray-50;
}

.cookie-category {
  @apply border border-gray-200 rounded-lg p-4;
}

.category-header {
  @apply space-y-2;
}

.toggle-container {
  @apply flex items-center gap-3;
}

.toggle {
  @apply relative inline-flex h-6 w-11 rounded-full transition-colors duration-200 ease-in-out focus:outline-none;
}

.toggle-active {
  @apply bg-green-600;
}

.toggle-inactive {
  @apply bg-gray-300;
}

.toggle-disabled {
  @apply bg-green-600 opacity-50 cursor-not-allowed;
}

.toggle-switch {
  @apply inline-block h-4 w-4 transform rounded-full bg-white transition duration-200 ease-in-out;
}

.toggle-switch-active {
  @apply translate-x-6;
}

.toggle-switch-inactive {
  @apply translate-x-1;
}

.toggle-label {
  @apply text-sm text-gray-600;
}

.cookie-details {
  @apply mt-2 pl-4 border-l-2 border-green-200;
}

.btn-secondary {
  @apply px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors;
}

.btn-accept-all {
  @apply px-4 py-2 text-sm font-medium text-white bg-green-600 border border-transparent rounded-md hover:bg-green-700 transition-colors;
}

.btn-save {
  @apply px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 transition-colors;
}
</style>